import { configUtils } from 'app/config_utils';

export const BUILD_URL = configUtils.buildUrl;
